export const CSV = '(comma-separated)';
export const XLS = '(MS Excel Spreadsheet)';
export const XLSX = '(MS Excel 2010+)';
